import { GENERATE_USER_SESSION_ID, STOP_USER_TO_PURCHASE,RESET_STOP_USER_TO_PURCHASE } from "../actions/actionGlobal";
import { loadState, saveState } from "../helpers/sessionStorage";
import create_UUID from '../helpers/userIdentifier';

const USER_IDENTIFIER = "userIdentifierID";
const STOP_USER = "stopUserToPur";

const initialState = {
    sessionID: loadState(USER_IDENTIFIER, ''),
    stopUserToPurchase: loadState(STOP_USER, false)
};

function reducerGlobal(state = initialState, action) {
    switch (action.type) {
        case GENERATE_USER_SESSION_ID: {

            let userIdentifyID = create_UUID();
            saveState(USER_IDENTIFIER, userIdentifyID);

            return {
                ...state,
                sessionID: userIdentifyID
            };
        }
        case STOP_USER_TO_PURCHASE: {

            saveState(STOP_USER, true);

            return {
                ...state,
                stopUserToPurchase: true
            };
        }
        case RESET_STOP_USER_TO_PURCHASE :{

            saveState(STOP_USER, false);

            return {
                ...state,
                stopUserToPurchase: false
            };

        }
        default: {
            return state;
        }
    }
}

export default reducerGlobal;